// 🔹 HTTP Client
import axiosInstance from "../../helpers/axios";

// 🔹 Dispatch Helpers
import {
  catchHandler,
  dispatchError,
  dispatchLoading,
  dispatchToast,
  elseHandler,
} from "../../helpers/dispatch";

// 🔹 Encryption Utilities
import { responseDataFormate } from "../../helpers/bycrypt";

export const GetSummaryDetails =
  (params?: Record<string, any>, limit?: number, setHasMore?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getSummaryDetails", true);

    axiosInstance
      .get("/category-summary", {
        params,
        withCredentials: false,
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          dispatch({
            type: "GET_SUMMARY_DETAILS_DATA",
            payload: result?.data,
          });
        } else {
          elseHandler(dispatch, "getSummaryDetails", result);
        }

        if (setHasMore) {
          setHasMore(result?.data?.data?.length == limit);
        }

        dispatchLoading(dispatch, "getSummaryDetails", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getSummaryDetails")(err);
      });
  };

export const UpdateCategorySummaryAPI =
  (data: any, onSuccess?: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateCategorySummary", true);

    axiosInstance
      .put(`/category-summary`, data)
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          const updatedData = result?.data;

          dispatch({
            type: "UPDATE_SUMMARY_DETAILS_DATA",
            payload: updatedData,
          });

          dispatchToast(dispatch, "success", result?.message);

          onSuccess?.();
        } else {
          elseHandler(dispatch, "updateCategorySummary", result);
        }

        dispatchLoading(dispatch, "updateCategorySummary", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "updateCategorySummary")(err);
      });
  };
